import { usePermissionsRepository } from '@Hooks/useRepository';
import { UsersRepository } from '@Repositories/Permissions';
import { useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useBlockUser = (userId: string, refetchData: () => void) => {
    const users = usePermissionsRepository(UsersRepository);
    const { pushAllToasts } = useToasts();

    const { mutateAsync, isPending: blockUserIsPending } = useMutation({
        mutationFn: () => users.blockUser(userId),
    });

    const blockUserHandler = useCallback(async () => {
        const result = await mutateAsync();
        pushAllToasts(result.messages);
        refetchData();
    }, [mutateAsync, pushAllToasts, refetchData]);

    return { blockUserHandler, blockUserIsPending };
};
